// import React from 'react';
// import { ReactSVG } from 'react-svg';
// import { Tooltip } from 'antd';
// import robot_svg from '../../../../assets/images/robot.svg';

import { ReactSVG } from 'react-svg';
import React, { CSSProperties, useMemo } from 'react';
import { Popover } from 'antd';
import robot_svg from '../../../../assets/images/robot.svg';
import emergency_svg from '../../../../assets/images/emergency.svg';
import cleaning_svg from '../../../../assets/images/cleaning.svg';
import greening_svg from '../../../../assets/images/greening.svg';
import equipment_svg from '../../../../assets/images/equipments.svg';
import { Robot, Worker } from '../../../model/workers_response';
import {getRobotState, WorkerStatus} from '../../../constant';
import { RobotDetail, WorkerDetail } from './worker_details';
import { useMainStore } from '../../pages/main/main_store';

const EmergencyIcon :React.FC<{ show: boolean }> = ({ show }) => {
  return show ? (
        <ReactSVG
            style={{
              position: 'absolute',
              top: '0',
              right: '-5px',
              width: '40%',
              height: '40%',
              zIndex: 1,
            }}
            src={emergency_svg}
            className={'emergency'}
            beforeInjection={(svg) => {
              svg.setAttribute('style', 'width:100%; height: 100%; ');
            }}
        />
  ) : null;
};

const RobotSvg :React.FC<{ className: string }> = ({ className }) => {
  return <ReactSVG
        className={'robot ' + className}
        style={{
          position: 'absolute',
          top: '0',
          left: '0',
        }}
        src={robot_svg}
        beforeInjection={(svg) => {
          svg.setAttribute('style', 'width:100%; height: 100%;');
        }}
    />;
};

const CleaningSvg: React.FC<{ className: string }> = ({ className }) => {
  return <ReactSVG
        className={'cleaning ' + className}
        style={{
          position: 'absolute',
          top: '0',
          left: '0',
        }}
        src={cleaning_svg}
        beforeInjection={(svg) => {
          svg.setAttribute('style', 'width:100%; height: 100%;');
        }}
    />;
};


const GreeningSvg: React.FC<{ className: string }> = ({ className }) => {
  return <ReactSVG
        className={'cleaning ' + className}
        style={{
          position: 'absolute',
          top: '0',
          left: '0',
        }}
        src={greening_svg}
        beforeInjection={(svg) => {
          svg.setAttribute('style', 'width:100%; height: 100%;');
        }}
    />;
};


const EquipmentSvg: React.FC<{ className: string }> = ({ className }) => {
  return <ReactSVG
        className={'cleaning ' + className}
        style={{
          position: 'absolute',
          top: '0',
          left: '0',
        }}
        src={equipment_svg}
        beforeInjection={(svg) => {
          svg.setAttribute('style', 'width:100%; height: 100%;');
        }}
    />;
};
const css: CSSProperties = { position: 'relative', width: '50px', height: '50px' };

export const RobotIcon: React.FC<{ robot: Robot }> = ({ robot }) => {
  const { hoverWorkerId, setHoverWorkerId, setWorkerId } = useMainStore((selector) => selector);
  const { isStop, isCaution } = getRobotState(robot.status.operationState);
  const classNames = useMemo(() => {
    if (isCaution) {
      return 'alert';
    }
    if (isStop) {
      return 'offline';
    }
    return '';
  }, [robot.status.operationState]);

  const handleOpenChange = (open: boolean) => {
    if (open) {
      setHoverWorkerId('robot-' + robot.robotId);
    } else {
      setHoverWorkerId('');
    }
  };

  return (
        <Popover placement={'top'} content={<RobotDetail robot={robot}/>} trigger={'hover'} open={hoverWorkerId === 'robot-' + robot.robotId} onOpenChange={handleOpenChange}>
            <div style={css} onClick={() => { setWorkerId({ type: 'robot', id: robot.robotId }); }}>
                <RobotSvg className={classNames}/>
                <EmergencyIcon show={isCaution} />
            </div>
        </Popover>
  );
};

export const WorkersIcon: React.FC<{ worker: Worker }> = ({ worker }) => {
  const { hoverWorkerId, setHoverWorkerId, setWorkerId } = useMainStore((selector) => selector);
  const classNames = (status: WorkerStatus) => {
    switch (status) {
      case WorkerStatus.EMERGENCY:
        return 'alert';
      case WorkerStatus.BREAK:
        return 'offline';
      default:
        return '';
    }
  };
  const icon = useMemo(() => {
    const className = classNames(worker.status);
    switch (worker.businessType) {
      case 'cleaning':
        return <CleaningSvg className={className} />;
      case 'greening':
        return <GreeningSvg className={className} />;
      case 'equipment':
        return <EquipmentSvg className={className} />;
      default:
        return <RobotSvg className={className} />;
    }
  }, [worker.businessType, worker.status]);

  const handleOpenChange = (open: boolean) => {
    if (open) {
      setHoverWorkerId('worker-' + worker.deviceId);
    } else {
      setHoverWorkerId('');
    }
  };

  return (
      <Popover placement={'top'} content={<WorkerDetail worker={worker}/>} trigger={'hover'} open={hoverWorkerId === 'worker-' + worker.deviceId} onOpenChange={handleOpenChange}>
          <div style={css} onClick={() => { setWorkerId({ type: 'worker', id: worker.deviceId }); }}>
              {icon}
              <EmergencyIcon show={worker.status === WorkerStatus.EMERGENCY}/>
          </div>
      </Popover>
  );
};
